<script>
	import store from "../../store.js";
	import {Style, Icon as IconStyle} from "ol/style";

	export default {
		sessionUrl: "/map/webapp/sessionServlet",
		getAtlasPathData: function(path){
			var regExp = new RegExp("^/atlas/([^/]+)(?:/(edit|view)?)?$"),
				match = path.match(regExp),
				data;
			if (match) {
				data = [match[1], match[2]];
			}
			return data;
		},
		getUserData: function(){
			var promise = new Promise(function(resolve, reject){
				if (store.state.userData) {
					resolve(store.state.userData);
				} else {
					var url = "/map/webapp/rest/userservice";
					setTimeout(function(){
						window.fetch(url, {
							method: "GET",
							headers: {
								"Content-Type": "application/json"
							}
						}).then(function(response){
							if (response.status == 200) {
								return response.text();
							} else {
								reject();
							}
						}).then(function(text){
							var userData;
							if (text) {
								try {
									var json = JSON.parse(text);
									if (json) {
										userData = json;
									}
								} catch(err) {
									// ...
								}
							}
							if (userData) {
								store.commit("setUserData", userData);
								resolve(userData);
							} else {
								reject();
							}
						}.bind(this), function(){
							reject();
						});
					}.bind(this));
				}
			});
			return promise;
		},
		isUserAdmin: function(){
			if (store.state.userData && store.state.userData.userRoles) {
				if (store.state.userData.userRoles.indexOf("El. paslaugų administratorius") != -1) {
					return true;
				}
			}
		},
		isUserSigned: function(){
			if(store.state.userData.anonymous == false) {
				return true;
			}			
		},
		getMapConfig: function(myMap){
			var config = {};
			if (myMap.map) {
				config.zoom = myMap.map.getView().getZoom();
				config.center = myMap.map.getView().getCenter();
				var layers = [],
					service;
				myMap.getLayers().forEach(function(layer){
					if (layer.service) {
						service = {
							visible: layer.get("visible"),
							opacity: layer.get("opacity")
						};
						if (layer.service.base) {
							service.base = layer.service.base;
						} else {
							if (layer.service.id) {
								service.id = layer.service.id;
							} else if (layer.service.rawOriginalUrl) {
								service.url = layer.service.rawOriginalUrl;
							}
						}
						if (layer.getSource().getParams) {
							var sourceParams = layer.getSource().getParams();
							service.layers = sourceParams["layers"]; // Tai sluoksnio sublayer'ių matomumą apibrėžiantis parametras...
						}
						if (layer.service.type == "edvi-vector" || layer.service.type == "edvi-raster") {
							service.type = layer.service.type;
						}
						service.identifyEnabled = layer.service.identifyEnabled;
						layers.push(service);
					}
				});
				if (myMap.map.identifyPointLayer) {
					var identifyFeatures = myMap.map.identifyPointLayer.getSource().getFeatures();
					if (identifyFeatures.length == 1) {
						config.identifyPoint = identifyFeatures[0].getGeometry().getCoordinates();
					}
				}
				config.layers = layers;
				if (myMap.noLegendInPreview) {
					config.noLegendInPreview = myMap.noLegendInPreview;
				}
			}
			return config;
		},
		svgPathToDataUri: function(imgSize, feature, highlightActive){
			if (!imgSize) {
				imgSize = [24, 24];
			}
			var strokeColor = "#222222",
				color = feature.get("color") || "#000000";
			if (highlightActive && feature.get("active")) {
				strokeColor = "#03a9f4";
			}
			var svgPath = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" height="' + imgSize[0] + '" viewBox="0 0 ' + imgSize[0] + ' ' + imgSize[1] + '" width="' + imgSize[1] + '"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" stroke="' + strokeColor + '" fill="' + color + '" /><path d="M0 0h24v24H0z" fill="none"/></svg>';
			var dataUri = "data:image/svg+xml;base64," + btoa(svgPath);
			return dataUri;
		},
		getSwatches: function(){
			var swatches = [
				['#FF0000', '#AA0000', '#550000'],
				['#FFFF00', '#AAAA00', '#555500'],
				['#00FF00', '#00AA00', '#005500'],
				['#00FFFF', '#00AAAA', '#005555'],
				['#0000FF', '#0000AA', '#000055']
			];
			return swatches
		},
		sortFeatures: function(features){
			features.sort(function(a, b) {
				return a.getId() - b.getId();
			});
		},
		getMyObjectsStyle: function(){
			var styleFunction = function(feature){
				var imgSize = [24, 24];
				var style = {
					image: new IconStyle({
						src: this.svgPathToDataUri(imgSize, feature, true),
						imgSize: imgSize,
						anchorOrigin: "bottom-left",
						anchor: [imgSize[0]/2, 2],
						anchorXUnits: "pixels",
						anchorYUnits: "pixels",
						scale: feature.get("active") ? 2 : 1.4,
						opacity: 0.9
					})
				};
				style = new Style(style);
				return style;
			}.bind(this);
			return styleFunction;
		},
		isMineAtlas: function(atlas){
			// EX funkcionalumas, kol nebuvo `role` parametro:
			/*
			if (store.state.userData && atlas["owner"] && (atlas["owner"].toLowerCase() == store.state.userData["userName"].toLowerCase())) {
				return true;
			}
			if (!atlas["owner"]) {
				return true; // Laikinai, kol Linas nepadarė, kad getAtlas() grąžintų owner'io?.. Dabar UI pusėje neleidžiame žmogui patekti į AtlasSummary puslapį, jei jis nėra atlaso autorius...
			}
			*/
			if (atlas["role"] == "owner") {
				return true;
			}
		},
		sendEmail: function(type, msgContent){
			var promise = new Promise(function(resolve, reject){
				var url = "/atlas/admin/api/Email/SendEmail",
					subjectType;
				if (type == 1) {
					subjectType = "Svarbi info";
				} else if (type == 2) {
					subjectType = "Geoportal.lt atlasas - suteiktos teisės";
				} else if (type == 3) {
					subjectType = "Geoportal.lt atlasas - panaikintos teisės";
				}
				if (type == 2 || type == 3) {
					if (msgContent[2] == "reader") {
						msgContent[2] = "peržiūrėti";
					} else if (msgContent[2] == "editor") {
						msgContent[2] = "redaguoti";
					}
				}
				var params = {
					"TemplateNo": type,
					"SubjectType": subjectType,
					"SendTo": "Svecias1",
					"MsgContent": msgContent
				};
				setTimeout(function(){
					window.fetch(url, {
						method: "POST",
						body: JSON.stringify(params),
						headers: {
							"Content-Type": "application/json"
						}
					}).then(function(response){
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function(text){
						var success;
						if (text) {
							try {
								var json = JSON.parse(text);
								if (json) {
									if (json.success) {
										success = true;
									}
								}
							} catch(err) {
								// ...
							}
						}
						if (success) {
							resolve();
						} else {
							reject();
						}
					}.bind(this), function(){
						reject();
					});
				}.bind(this));
			});
			return promise;
		}
	}
</script>